<template>
  <Card :class="isDense ? 'p-4 text-center' : 'p-8 text-center'">
    <p
      class="mx-auto max-w-xl text-red-600"
      :class="isDense ? 'text-xs' : 'text-sm'"
    >
      Could not check which features your organization has access to. This is a
      loading problem, not a change to your plan.
    </p>
    <div class="mt-4 flex justify-center">
      <button type="button" class="btn btn-outline" @click="emit('retry')">
        Retry
      </button>
    </div>
  </Card>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import Card from "@/components/Core/Card.vue";
import {
  PAYWALL_VARIANTS,
  type PaywallVariant,
} from "@/services/paywall_content";

const props = defineProps({
  variant: {
    type: String as PropType<PaywallVariant>,
    default: "full",
    validator: (value: string) =>
      PAYWALL_VARIANTS.includes(value as PaywallVariant),
  },
});

const emit = defineEmits({ retry: () => true });

// `inline` has no error layout of its own; it sits in a page that still works,
// so it takes the compact density rather than the full card's p-8. Keyed by
// the union so a new variant must state its density here.
const DENSE_BY_VARIANT: Record<PaywallVariant, boolean> = {
  full: false,
  compact: true,
  inline: true,
};

const isDense = computed(() => DENSE_BY_VARIANT[props.variant]);
</script>
